(() => {
  const choiceData = (button) => button ? {
    variantId: Number(button.dataset.variantId),
    title: button.dataset.title || '',
    price: Number(button.dataset.price || 0),
    image: button.dataset.image || '',
    letter: button.dataset.letter || ''
  } : null;

  const formatMoney = (cents) => new Intl.NumberFormat('tr-TR', {
    style: 'currency', currency: 'TRY', minimumFractionDigits: 0, maximumFractionDigits: 2
  }).format((Number(cents) || 0) / 100);

  const setPressed = (buttons, active) => buttons.forEach((button) => {
    const selected = button === active;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });

  const currentMainVariant = (section) => {
    const input = document.querySelector('.main-product product-form input[name="id"]');
    return Number(input?.value || section.dataset.mainVariantId);
  };

  const init = (section) => {
    if (!section || section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';

    const charmButtons = [...section.querySelectorAll('[data-tale-set-choice="charm"]')];
    const twillyButtons = [...section.querySelectorAll('[data-tale-set-choice="twilly"]')];
    const noTwilly = section.querySelector('[data-tale-set-choice="twilly-none"]');
    const addButton = section.querySelector('[data-tale-set-add]');
    const status = section.querySelector('[data-tale-set-status]');
    const charmLine = section.querySelector('[data-tale-set-charm-line]');
    const twillyLine = section.querySelector('[data-tale-set-twilly-line]');
    const discountLine = section.querySelector('[data-tale-set-discount-line]');
    const totalNodes = section.querySelectorAll('[data-tale-set-total], [data-tale-set-button-total]');
    const previewCharm = section.querySelector('[data-tale-preview-charm]');
    const previewTwilly = section.querySelector('[data-tale-preview-twilly]');
    const mainPrice = Number(section.dataset.mainPrice || 0);
    const discountPercent = Math.max(0, Number(section.dataset.discountPercent || 0));
    const discountCode = section.dataset.discountCode || '';
    let charm = null;
    let twilly = null;

    const renderLine = (line, item) => {
      if (!line) return;
      line.hidden = !item;
      if (!item) return;
      line.querySelector('span').textContent = item.title;
      line.querySelector('strong').textContent = formatMoney(item.price);
    };

    const render = () => {
      const subtotal = mainPrice + (charm?.price || 0) + (twilly?.price || 0);
      const discount = discountCode ? Math.round(subtotal * discountPercent / 100) : 0;
      const total = Math.max(0, subtotal - discount);
      renderLine(charmLine, charm);
      renderLine(twillyLine, twilly);
      if (discountLine) discountLine.querySelector('strong').textContent = `−${formatMoney(discount)}`;
      totalNodes.forEach((node) => { node.textContent = formatMoney(total); });
      addButton.disabled = !charm;
      if (previewCharm) {
        previewCharm.hidden = !charm;
        if (charm) previewCharm.querySelector('strong').textContent = charm.letter;
      }
      if (previewTwilly) {
        previewTwilly.hidden = !twilly;
        if (twilly) {
          const image = previewTwilly.querySelector('img');
          image.src = twilly.image;
          image.alt = twilly.title;
          previewTwilly.querySelector('span').textContent = twilly.title;
        }
      }
    };

    charmButtons.forEach((button) => button.addEventListener('click', () => {
      charm = choiceData(button);
      setPressed(charmButtons, button);
      render();
    }));

    twillyButtons.forEach((button) => button.addEventListener('click', () => {
      twilly = choiceData(button);
      setPressed(twillyButtons, button);
      if (noTwilly) {
        noTwilly.classList.remove('is-selected');
        noTwilly.setAttribute('aria-pressed', 'false');
      }
      render();
    }));

    noTwilly?.addEventListener('click', () => {
      twilly = null;
      setPressed(twillyButtons, null);
      noTwilly.classList.add('is-selected');
      noTwilly.setAttribute('aria-pressed', 'true');
      render();
    });

    addButton?.addEventListener('click', async () => {
      if (!charm || addButton.disabled) return;
      addButton.disabled = true;
      addButton.classList.add('is-loading');
      if (status) status.textContent = 'Set sepete ekleniyor…';
      const setId = `TALE-${Date.now().toString(36).toUpperCase()}`;
      const items = [
        { id: currentMainVariant(section), quantity: 1, properties: { '_TALE Seti': setId } },
        { id: charm.variantId, quantity: 1, properties: { '_TALE Seti': setId, 'Gravür Harfi': charm.letter } }
      ];
      if (twilly) items.push({ id: twilly.variantId, quantity: 1, properties: { '_TALE Seti': setId } });

      try {
        const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Set sepete eklenemedi.');
        }
        const redirect = discountCode
          ? `${root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent('/cart')}`
          : `${root}cart`;
        window.location.assign(redirect);
      } catch (error) {
        if (status) status.textContent = error.message || 'Set sepete eklenemedi. Lütfen yeniden deneyin.';
        addButton.disabled = false;
        addButton.classList.remove('is-loading');
      }
    });

    noTwilly?.classList.add('is-selected');
    render();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-tale-pdp-personalizer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
